import libraryFetch from "@/api/libraryFetch";

/**
 * 用于存放组建通信的临时数据
 */

const state = {
  articleReferenceItem: null,
  articleSensitiveTexts: {},
  articleRelatedLibrarys: [],
  chatBotToUserInfo: null,
  chatBotInfoData: null,
  prev_menu_id: "",
  specificPostData: null,
  emailInfo: {},
  /**
   * 邮件场景设置查物流邮件正文
   * @type {EmailTrackContentTab[]}
   */
  emailTrackContentTabs: [],
  emailHeadFootTemplate: {
    header: "",
    footer: "",
  },
  botTreePath: [],
  moreSceneRequestParam: {},
  postsPreivewData: {},
  pendingFestivalAiPrompt: "",
};
const mutations = {
  stashPostsPreivewData(state, data) {
    state.postsPreivewData = data;
  },
  stashPendingFestivalAiPrompt(state, data) {
    state.pendingFestivalAiPrompt = data || "";
  },
  updateEmailInfoFormUser(state, data) {
    state.emailInfo.email_obj.form_user = data;
  },
  stashMoreSceneRequestParam(state, data) {
    state.moreSceneRequestParam = data;
  },
  stashBotTreePath(state, path) {
    state.botTreePath = path;
  },
  /**
   * 存储邮件默认头模板
   * @param state
   * @param {string} headTemplate
   */
  stashEmailHeadTemplate(state, headTemplate) {
    state.emailHeadFootTemplate.header = headTemplate;
  },
  /**
   * 存储邮件默认尾模板
   * @param state
   * @param {string} footTemplate
   */
  stashEmailFootTemplate(state, footTemplate) {
    state.emailHeadFootTemplate.footer = footTemplate;
  },
  stashEmailTrackContentTabs(state, data) {
    state.emailTrackContentTabs = data;
  },
  stashEmailInfo(state, data) {
    state.emailInfo = data;
  },
  stashSpecificPostData(state, data) {
    state.specificPostData = data;
  },
  stashBotFormData(state, data) {
    state.chatBotInfoData = data;
  },
  stashChatBotUserInfo(state, data) {
    state.chatBotToUserInfo = data;
  },
  setArticleRelatedLibrarys(state, data) {
    state.articleRelatedLibrarys = data;
  },
  setArticleReferenceItem(state, data) {
    state.articleReferenceItem = data;
  },
  setArticleSensitiveTexts(state, data) {
    state.articleSensitiveTexts = data;
  },
  STASH_PREV_MENU_ID(state, data) {
    state.prev_menu_id = data;
    state.show_prev_menu = data?.length > 0;
  },
};
const actions = {
  async getArticleRelatedLibrarys({ commit }, param) {
    try {
      const res = await libraryFetch.getContents({
        page: 1,
        page_num: 200,
        ...param,
      });
      commit("setArticleRelatedLibrarys", res.data.data);
    } catch (error) {
      console.error("Error fetching article related librarys:", error);
    }
  },
};
const getters = {
  emailHeadFootTemplate: (state) => state.emailHeadFootTemplate,
  emailTrackContentTabs: (state) => state.emailTrackContentTabs,
  chatBotInfoData: (state) => state.chatBotInfoData,
  article_reference_item: (state) => state.articleReferenceItem,
  article_sensitive_texts: (state) => state.articleSensitiveTexts,
  article_related_librarys: (state) => state.articleRelatedLibrarys,
  emailInfo: (state) => state.emailInfo,
  botTreePath: (state) => state.botTreePath,
  moreSceneRequestParam: (state) => state.moreSceneRequestParam,
  pendingFestivalAiPrompt: (state) => state.pendingFestivalAiPrompt,
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

/**
 * @typedef {Object} EmailTrackContentTab
 * @property {(1|2|3|4)} logistics_status 1 已发货订单 2 未发货订单 3 交易单号不存在 4 未提供交易单号
 * @property {number} reply_settings
 * @property {string} template
 * @property {string} template_placeholder
 */
